"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Storage = exports.PermissionRole = exports.AllowedFilterOperator = exports.DataOperation = exports.FieldType = void 0;
var FieldType;
(function (FieldType) {
    /**
     * JSON Number (Ex. 2 or 26.7)
     */
    FieldType["number"] = "number";
    /**
     * JSON String
     */
    FieldType["text"] = "text";
    /**
     * Wix Media or HTTP(S) url to an image,
     * image://...
     */
    FieldType["image"] = "image";
    /**
     * JSON Boolean (true, false)
     */
    FieldType["boolean"] = "boolean";
    /**
     * Wix Media link to a document, in form wix:media://...
     */
    FieldType["document"] = "document";
    /**
     * HTTP(S) URL as a JSON String
     */
    FieldType["url"] = "url";
    /**
     * HTML String with tags allowed in Wix RichText.
     */
    FieldType["richText"] = "richtext";
    /**
     * Date time type represented as an object with $date attribute
     * holding ISO 8601 string with UTC date.
     *
     * Example: { $date: '2018-04-01T00:00:00Z' }
     *
     * This will get transformed to JavaScript Date on the client side.
     */
    FieldType["dateTime"] = "datetime";
    /**
     * Wix Media link to video
     */
    FieldType["video"] = "video";
    /**
     * String ID to referenced item.
     *
     * If specified in a collection together with referencedCollectionName,
     * Wix Data will handle the includes by making additional request to
     * included collection using hasSome filter and passing down ids of the
     * items to be included.
     */
    FieldType["reference"] = "reference";
    /**
     * Multi-reference fields are not yet directly supported in DB Drivers.
     * Consult Wix Data team before trying to use it.
     */
    FieldType["multiReference"] = "multi-reference";
    /**
     * Relative URL to a page in a site.
     */
    FieldType["pageLink"] = "pagelink";
    /**
     * JSON Object as plain JSON.
     */
    FieldType["object"] = "object";
    /**
     * Gallery type for binding to Pro Gallery components.
     */
    FieldType["mediaGallery"] = "media-gallery";
    /**
     * Address type.
     * See https://docs.google.com/document/d/1pwZKxnBBxR1mBnJGiS6M6qSdjKd1YDJ2OAM4nHJjFS8/edit#heading=h.5ndfgx3b0knm
     *
     * Items should at very least contain 'formatted' property.
     */
    FieldType["address"] = "address";
    /**
     * Array of strings type.
     */
    FieldType["stringArray"] = "array<string>";
    /**
     * JSON Color Hex String
     */
    FieldType["color"] = "color";
    /**
     * Wix Media link to audio
     */
    FieldType["audio"] = "audio";
    /**
     * JSON String holding time in a following format: '00:00:00'
     */
    FieldType["time"] = "time";
    /**
     * Array
     */
    FieldType["array"] = "array";
})(FieldType = exports.FieldType || (exports.FieldType = {}));
var DataOperation;
(function (DataOperation) {
    DataOperation["insert"] = "insert";
    DataOperation["update"] = "update";
    DataOperation["get"] = "get";
    DataOperation["remove"] = "remove";
    DataOperation["find"] = "find";
    DataOperation["count"] = "count";
})(DataOperation = exports.DataOperation || (exports.DataOperation = {}));
var AllowedFilterOperator;
(function (AllowedFilterOperator) {
    AllowedFilterOperator["eq"] = "eq";
    AllowedFilterOperator["ne"] = "ne";
    AllowedFilterOperator["lt"] = "lt";
    AllowedFilterOperator["lte"] = "lte";
    AllowedFilterOperator["gt"] = "gt";
    AllowedFilterOperator["gte"] = "gte";
    AllowedFilterOperator["hasSome"] = "hasSome";
    AllowedFilterOperator["hasAll"] = "hasAll";
    AllowedFilterOperator["contains"] = "contains";
    AllowedFilterOperator["startsWith"] = "startsWith";
    AllowedFilterOperator["endsWith"] = "endsWith";
    AllowedFilterOperator["urlized"] = "urlized";
})(AllowedFilterOperator = exports.AllowedFilterOperator || (exports.AllowedFilterOperator = {}));
var PermissionRole;
(function (PermissionRole) {
    /**
     * Anyone (anonymous) can perform the operation
     */
    PermissionRole["anyone"] = "anyone";
    /**
     * User of user can perform the opration
     */
    PermissionRole["siteMember"] = "siteMember";
    /**
     * User of user who is the owner (producer) of the
     * data can perform the operation.
     *
     * In regular Wix Data collections, this allows
     * performing operation on an item if _owner field
     * matches the currently logged Site Member id.
     *
     * In case of DB drivers, this can match the
     * ownership that is appropriate to vertical, ex.:
     * UoU can see his purchases, or contact can see
     * his details.
     */
    PermissionRole["siteMemberAuthor"] = "siteMemberAuthor";
    /**
     * Site Admin can perform the operation.
     */
    PermissionRole["admin"] = "admin";
})(PermissionRole = exports.PermissionRole || (exports.PermissionRole = {}));
var Storage;
(function (Storage) {
    /**
     * DB driver collection
     */
    Storage["driver"] = "driver";
    /**
     * User collection
     */
    Storage["docstore"] = "docstore";
    /**
     * App builder collection
     */
    Storage["app"] = "app";
    /**
     * External db driver collection
     */
    Storage["expernal"] = "external";
})(Storage = exports.Storage || (exports.Storage = {}));
//# sourceMappingURL=schema.js.map